<div class="form-group" [class.required]="innerRequired">
  <form #form="ngForm">
    <label [for]="name">{{label}}</label>
    <select [required]="innerRequired" [disabled]="innerDisabled" class="form-control" [id]="name" [name]="name" [(ngModel)]="value">
      <option></option>
      <option *ngFor="let availableValue of availableValues" [ngValue]="availableValue">{{availableValue}}</option>
    </select>
  </form>
</div>
